import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'Poppins, Arial, sans-serif',
  },
  palette: {
    primary: {
      main: '#ff005a',
    },
    error: {
      main: '#f44336',
      light: '#FFCDD2',
    },
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          color: '#222121',
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
            backgroundColor: '#f4f4f4',
            color: '#222121',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            border: 'none',
            backgroundColor: '#e4e4e4',
            color: '#222121',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none',
            color: '#222121',
          },
          '& .MuiInputAdornment-root': {
            color: '#222121', // Assurez-vous que l'icône pour afficher le mot de passe est visible
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          backgroundColor: 'transparent',
          color: '#222121',
          '&.Mui-focused': {
            color: 'redpink',
          },
          '&.Mui-error': {
            color: '#ff005a',
            '&.MuiInputLabel-root': {
              backgroundColor: 'none',
            },
          },
          '&:hover .MuiInputLabel-root': {
            backgroundColor: '#e4e4e4',
          },
          '&.MuiInputLabel-shrink': {
            textTransform: 'uppercase',
            color: '#ff005a',
            fontWeight: 'bold',
            transform: 'translate(5, -10px) scale(0.75)',
            backgroundColor: 'none',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          backgroundColor: '#f4f4f4',
          color: '#222121',
          borderRadius: '5px',
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '& .MuiInputBase-input': {
            color: '#222121', // Assurez-vous que le texte écrit est visible
          },
          '& .MuiInputBase-input.Mui-error': {
            color: '#d4d4d4',
          },
          '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#ff005a',
          },
          '& .MuiInputLabel-root': {
            color: '#222121',
          },
          '& .Mui-focused .MuiInputLabel-root, & .MuiInputLabel-shrink': {
            color: '#ff005a',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            backgroundColor: 'none',
            transform: 'translate(5, -10px) scale(0.75)',
          },
          '& .MuiInputBase-input.Mui-disabled': {
            WebkitTextFillColor: '#222121',
          },
          '&:hover': {
            backgroundColor: '#e4e4e4',
          },
          '& .Mui-error': {
            '& .MuiInputLabel-root': {
              backgroundColor: 'none',
            },
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          backgroundColor: '#f4f4f4',
          color: '#222121',
          borderRadius: '5px',
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '& .MuiSelect-select': {
            color: '#222121',
          },
          '& .MuiSelect-select.Mui-error': {
            color: '#d4d4d4',
          },
          '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#ff005a',
          },
          '& .MuiInputLabel-root': {
            color: '#222121',
          },
          '& .MuiInputLabel-shrink': {
            color: '#ff005a',
            fontWeight: 'bold',
            textTransform: 'uppercase',
          },
          '& .MuiSelect-select.Mui-disabled': {
            WebkitTextFillColor: '#222121',
          },
          '&:hover': {
            backgroundColor: '#e4e4e4',
          },
          '& .Mui-error': {
            backgroundColor: '#FFCDD2',
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#f4f4f4',
            color: '#222121',
            borderRadius: '5px',
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
            '& .MuiInputBase-input': {
              color: '#222121',
            },
            '& .MuiInputBase-input.Mui-error': {
              color: '#222121',
            },
            '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#ff005a',
            },
            '& .MuiInputLabel-root': {
              color: '#222121',
            },
            '& .Mui-focused .MuiInputLabel-root, & .MuiInputLabel-shrink': {
              color: '#ff005a',
              fontWeight: 'bold',
              textTransform: 'uppercase',
            },
            '&:hover': {
              backgroundColor: '#e4e4e4',
            },
            '& .Mui-error': {
              backgroundColor: '#FFCDD2',
            },
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          backgroundColor: 'transparent',
        },
      },
    },
  },
});

export default theme;